import { isRealOnline, isStageFsim } from '@common/utils/env';

// adp域名区分 线上 仿真 测试
// 不需要修改： 仿真和测试默认使用根路径，用网关转发形式，本地开发使用proxy代理
const adpPath = {
  realOnLinePath: 'https://eapi.xiaolongcloud.com',

  stageFsimPath: '',
  testPath: '',
};

const getAdpPath = function () {
  if (isRealOnline()) {
    return adpPath.realOnLinePath;
  }
  if (isStageFsim()) {
    return adpPath.stageFsimPath;
  }
  return adpPath.testPath;
};

export default getAdpPath;
